import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const Trigger = (props) => {
  const btnClassNames = props.isQueueOpen ?
    classnames('unified-notification-queue-trigger-btn', 'trigger-queue-open', 'btn') :
    classnames('unified-notification-queue-trigger-btn', 'trigger-queue-close', 'btn');
  const bellClassNames = props.active ?
    classnames('alert-icon', 'notification-bell-active') :
    classnames('alert-icon', 'notification-bell-inactive');

  return (
    <div className="unified-notification-queue-trigger">
      {props.isUINext ? (
        <button id={props.id} className={btnClassNames} onClick={props.action} tabIndex={props.disableKeyboardNav ? -1 : 0} role={props.triggerButtonRole}>
          <div>
            <span className={bellClassNames} />
            <div className="unified-notification-queue-trigger-text" title={props.text}>{props.text}</div>
          </div>
        </button>
      ) : (
        <button id={props.id} className={bellClassNames} onClick={props.action} />
      )}
    </div>
  );
};

Trigger.propTypes = {
  isQueueOpen: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  action: PropTypes.func,
  isUINext: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string,
  disableKeyboardNav: PropTypes.bool,
  triggerButtonRole: PropTypes.string,
};

Trigger.defaultProps = {
  isQueueOpen: false,
  action: _.noop,
  id: 'unified-notification-queue-trigger-btn-id', // For popover identifying trigger button
  disableKeyboardNav: false,
  triggerButtonRole: '',
};
